import { useSelector } from "react-redux";
import { RootState } from "@/store";

export const useCavOfflineSyncState = () => {
  return useSelector((state: RootState) => state.cavOfflineSyncFilter);
};
